import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/cache-logs",
	lazy(() => import("./AdminLoadCacheLogs"))
);
